import { useSelector, shallowEqual } from "react-redux";
import PaymentTermsInput from "app/pages/Booking/Payment/PaymentTermsInput/PaymentTermsInput";
import { shouldShowInformationStandardForm } from "app/pages/Booking/Payment/paymentSelector";
import { getShowPfsMessage } from "app/reducers/partnerSelector";

const mapStateToProps = state => {
	return {
		cgvDocumentName: state.documents.cgv,
		showInformationStandardForm: shouldShowInformationStandardForm(state),
		offerType: state.booking.offer.type,
		isInformationStandardFormHiddenOnHotelOnly:
			state.documents.isInformationStandardFormHiddenOnHotelOnly,
		informationStandardForm: state.documents.informationStandardForm,
		showPfsMessage: getShowPfsMessage(state),
	};
};

const PaymentTermsInputContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <PaymentTermsInput {...props} {...stateProps} />;
};

export default PaymentTermsInputContainer;
